// firebase-config.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { onMessage } from "firebase/messaging";
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const BRANCH_LIST_URL = `https://${process.env.REACT_APP_API_KEY_AUTH_BRANCH}.execute-api.ap-south-1.amazonaws.com/default/createBranch`;

// Add 'async' to the function definition
export default async function requestForToken(branchId) {
  // 1. Log the messaging object to see if projectId is attached

  // if (!messaging.app?.options?.projectId) {
  //   console.error("CRITICAL: projectId is missing from Firebase config!");
  // }
  if (Notification.permission === "denied") {
    console.warn(
      "Notifications are blocked by the user. Please enable them in browser settings.",
    );
    return; // Exit early so the code doesn't crash
  }
  // if (!messaging.app?.options?.projectId) {
  //   console.warn(
  //     "WARNING: projectId is missing from Firebase config during script load, but initialization might still happen.",
  //   );
  // }
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BI6vt_nvqftU59QeRyIcBmVqPgx05nyv0bLN5JnPRdDBmJWkonk1UY09ytJi3NjpUVGE38KFLwj1kctDhm9UyQ4",
      serviceWorkerRegistration: await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js",
      ),
    });

    if (currentToken) {
      if (!branchId || !currentToken) {
        return; // Don't make the API call if data is missing
      }

      const response = await fetch(BRANCH_LIST_URL, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: branchId, // Ensure this ID is passed into the function
          pushToken: currentToken,
          action: "UPDATE_PUSH_TOKEN",
        }),
      });

      if (response.ok) {
        console.log("Success: Push token saved to DynamoDB.");
      } else {
        const errorData = await response.json();
        console.error("Backend Error saving token:", errorData);
      }
    } else {
      console.warn(
        "No registration token available. Request permission to generate one.",
      );
    }
  } catch (err) {
    console.error("Firebase/Fetch Error Chain:", err);

    // Check for the specific 'projectId' error
    if (err.message.includes("projectId")) {
      console.error(
        "FIX: Check your firebaseConfig object in firebase-config.js. The 'projectId' field is likely undefined.",
      );
    }
  }
  onMessage(messaging, (payload) => {
    // Manually trigger an alert or a toast notification
    alert(
      `Notification: ${payload.notification.title} - ${payload.notification.body}`,
    );
  });
}
